'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bind;

var _createMemoizingGetter = require('nanotools/lib/createMemoizingGetter');

var _createMemoizingGetter2 = _interopRequireDefault(_createMemoizingGetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bind(proto, key, descriptor) {
  var fn, ref;
  fn = descriptor.value;
  if (typeof fn !== 'function') {
    throw new Error('@bind decorator (applied to ' + ((ref = proto.constructor) != null ? ref.name : void 0) + '.' + key + ') can only be applied to functions.');
  }
  return {
    configurable: true,
    get: (0, _createMemoizingGetter2.default)(proto, key, fn, function () {
      return fn.bind(this);
    })
  };
}